<template>
    <div class="w-full max-lg:px-3.75 text-sm md:text-base text-accent-gray-color grid grid-cols-4 h-10">

        <RouterLink class="p-1 flex items-center border-r border-r-gray-200" :class="{'border-b-2 border-solid border-main-color' : currentRoute === 'publication'}" :to="{ name: 'publicationHome' }">
            <p class="w-full text-main-color font-semibold text-lg truncate text-center text-ellipsis">{{ $t('nav.publications') }}</p>
        </RouterLink>

        <RouterLink class="p-1 flex items-center border-r border-r-gray-200" :class="{'border-b-2 border-solid border-main-color' : currentRoute === 'food'}" :to="{ name: 'foodHomePage' }">
            <p class="w-full text-main-color font-semibold text-lg truncate text-center text-ellipsis">{{ $t('nav.food') }}</p>
        </RouterLink>

        <RouterLink class="p-1 flex items-center border-r border-r-gray-200" :class="{'border-b-2 border-solid border-main-color' : currentRoute === 'mall'}" :to="{ name: 'mallHome' }">
            <p class="w-full text-main-color font-semibold text-lg truncate text-center text-ellipsis">{{ $t('nav.mall') }}</p>
        </RouterLink>

        <RouterLink class="p-1 flex items-center" :class="{'border-b-2 border-solid border-main-color' : currentRoute === 'media'}" :to="{ name: 'mediaHome' }">
            <p class="w-full text-main-color font-semibold text-lg truncate text-center text-ellipsis">{{ HABARLAR_ENABLED ? $t('nav.newsMedia') : $t('nav.media') }}</p>
        </RouterLink>

    </div>
</template>

<script>
import { FEATURE_FLAGS } from '@/constants'

export default {
    name: 'MiddleNav',
    data(){
        return {
            currentRoute: '',
            HABARLAR_ENABLED: FEATURE_FLAGS.HABARLAR
        }
    },
    watch: {
        '$route.path': {
            //   immediate: true,
            handler(newValue, oldValue) {
                if (newValue !== oldValue){
                    if (newValue.includes('mall')){
                        this.currentRoute = 'mall'
                    }
                    else if (newValue.includes('media')){
                        this.currentRoute = 'media'
                    }
                    else if (newValue.includes('profile')){
                        this.currentRoute = 'profile'
                    }
                    else if (newValue.includes('food')){
                        this.currentRoute = 'food'
                    }
                    else {
                        this.currentRoute = 'publication'
                    }
                }
                
            },
            immediate: true,
        },
    },
    methods: {

    },
    computed: {

    }
}
</script>

<!-- <style scoped>
.router-link-exact-active{
    border-bottom: 2px solid #212135;
}
</style> -->